import { FC } from "react";

interface DevicesModalTitleProps {
    label: string;
    onClose: () => void;
}

const DevicesModalTitle: FC<DevicesModalTitleProps> = (props) => {

    return(
        <div className="modal-primary__header">
            <div className="HorizontalFlex__JustifyBetween width-available">
                <div className="HorizontalFlex__Gap items__center">
                    <i
                        data-testid="closeButton"
                        className="far fa-arrow-left"
                        onClick={() => props.onClose()}
                    />
                    <p className="Services__ItemTitle">
                        {props.label}
                    </p>
                </div>
                <i
                    data-testid="closeButton"
                    className="far fa-times"
                    onClick={() => props.onClose()}
                />
            </div>
        </div>
    )
}

export default DevicesModalTitle